import _ from 'lodash';
import React, { Component } from 'react';

import Select, { createFilter } from 'react-select';

import {
  getIcon,
  getCountryIcon,
  getOptionValueForSelect,
} from '../../util';

import {
  getCountryOptions
} from '../../util/data';

const filterConfig = {
  ignoreCase: true,
  ignoreAccents: true
}

class CountrySelect extends Component {

  state = {
    countrySearch: ''
  }

  render(){

    const { currentCountry } = this.props;

    return (
      <div
        className={`country-select-container`}
      >
        <Select
          classNamePrefix={'react-select'}
          className={`react-select-container country-select`}
          value={getOptionValueForSelect(getCountryOptions(), currentCountry)}
          options={getCountryOptions()}
          onChange={(option) => { this.props.changeCountry(option.value); }}
          isSearchable={true}
          placeholder={this.props.placeholder}
          filterOption={createFilter(filterConfig)}
        />
      </div>
    )
  }
}
export default CountrySelect;



// WEBPACK FOOTER //
// ./src/components/shared/countrySelect.js